import { Component, Input, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiPathsService } from 'src/app/api-paths.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-gitlab-issue-creator',
  template: `
    <button type="submit" (click)="openModal()" style="margin: 0.75px;" class=" btn btn-orange  waves-effect waves-light">
      <span class="mr-1 text-white "> Crea Issue su GitLab </span>
      <i class="fab fa-gitlab text-white"></i>
    </button>
    <ng-template #modalContent let-modal>
      <div class="modal-header">
        <h4 class="modal-title">Seleziona il progetto</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <ul>
          <li *ngFor="let project of projects">
            <button class="btn btn-primary btn-sm" (click)="createIssues(project.id)">{{ project.name }}</button>
          </li>
        </ul>
      </div>
    </ng-template>
  `,
})
export class GitLabIssueCreatorComponent {
  @Input() issues: any[];
  @ViewChild('modalContent') modalContent: any;
  private readonly gitLabApiUrl = 'https://kufj48i3pmlat1z0.myfritz.net:66/api/v4';
  private readonly privateToken = 'glpat-_sHxD8fNFuvhz2SWdJbr';
  public projects: any[] = [];
  private modalRef: NgbModalRef;

  constructor(
    private modalService: NgbModal,
    private apiPaths: ApiPathsService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.getProjects();
  }

  openModal() {
    this.modalRef = this.modalService.open(this.modalContent, { centered: true, size: 'lg' });
  }

  getProjects() {
    try {
      const headers = new HttpHeaders({
        'PRIVATE-TOKEN': this.privateToken,
        'Content-Type': 'application/json',
      });

      this.http
        .get<any[]>(`${this.gitLabApiUrl}/projects`, { headers })
        .subscribe((response) => {
          this.projects = response;
        });
    } catch (error) {
      console.error(
        'Si è verificato un errore durante il recupero dei progetti:',
        error.message
      );
    }
  }

  createIssues(projectId: number) {
    const project = this.projects.find((p) => p.id === projectId);

    if (!project) {
      console.log('Progetto non valido.');
      return;
    }

    for (const issue of this.issues) {
      this.createOrUpdateGitLabIssue(
        project.id,
        issue.nome,
        issue.note,
        issue.data_fine_effettiva
      );
    }
  }

  createOrUpdateGitLabIssue(
    projectId: number,
    title: string,
    description: string,
    data_fine_effettiva?: string
  ) {
    try {
      this.http
        .get<any[]>(`${this.gitLabApiUrl}/projects/${projectId}/issues`, {
          headers: {
            'PRIVATE-TOKEN': this.privateToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe((response) => {
          const existingIssue = response.find((issue) => issue.title === title);

          if (existingIssue) {
            this.updateGitLabIssue(
              projectId,
              existingIssue.iid,
              title,
              description,
              data_fine_effettiva
            );
          } else {
            this.createGitLabIssue(projectId, title, description);
          }
        });
    } catch (error) {
      console.error(
        'Si è verificato un errore durante la creazione o l\'aggiornamento dell\'issue:',
        error.message
      );
    }
  }

  createGitLabIssue(projectId: number, title: string, description: string) {
    try {
      const headers = new HttpHeaders({
        'PRIVATE-TOKEN': this.privateToken,
        'Content-Type': 'application/json',
      });

      this.http
        .post<any>(
          `${this.gitLabApiUrl}/projects/${projectId}/issues`,
          { title, description },
          { headers }
        )
        .subscribe((response) => {
          console.log(
            `Nuovo issue creato su GitLab con ID: ${response.iid}`
          );
          this.modalRef.close(); // Chiude la modale dopo l'aggiornamento
        });
    } catch (error) {
      console.error(
        'Si è verificato un errore durante la creazione dell\'issue:',
        error.message
      );
    }
  }

  updateGitLabIssue(
    projectId: number,
    issueIid: number,
    title: string,
    description: string,
    data_fine_effettiva?: string
  ) {
    try {
      const issueUpdateData: any = {
        title,
        description,
      };

      if (data_fine_effettiva) {
        issueUpdateData.state_event = 'close';
      }

      const headers = new HttpHeaders({
        'PRIVATE-TOKEN': this.privateToken,
        'Content-Type': 'application/json',
      });

      this.http
        .put<any>(
          `${this.gitLabApiUrl}/projects/${projectId}/issues/${issueIid}`,
          issueUpdateData,
          { headers }
        )
        .subscribe((response) => {
          console.log(
            `Issue su GitLab aggiornato con ID: ${response.iid}`
          );
          this.modalRef.close(); // Chiude la modale dopo l'aggiornamento
        });
    } catch (error) {
      console.error(
        'Si è verificato un errore durante l\'aggiornamento dell\'issue:',
        error.message
      );
    }
  }
}
